export { getBannerLabel, resolveBannerLabel } from './get-banner-label';
